import React from 'react';
import contensis from 'Common/api/contensis';
import cmsParser from 'Common/util/cmsParser';
import setCacheHeaders from 'Common/func/setCacheHeaders';

import Metadata from 'Components/Metadata';
import MainLayout from 'Layout/Main';
import Template, { datamap, PageData } from 'Templates/TranscriptVideo';

import type { NextPageWithLayout, GetServerSideProps } from 'next';

const Video: NextPageWithLayout<PageData> = ({ entry, ancestors }) => {
    return (
        <>
            <Metadata {...cmsParser.metadata(entry)} />
            <Template {...datamap({ entry, ancestors })} />
        </>
    );
};

Video.getLayout = (page, props) => {
    return <MainLayout {...props}>{page}</MainLayout>;
};

export const getServerSideProps: GetServerSideProps<any> = async ({ params, preview, res }) => {
    const { fetch, surrogateKeys } = contensis({ preview, fetchSurrogateKeys: true });
    const { video } = params as { video: string };
    const { data, error } = await fetch(async client => {
        const resPage = await client.nodes.get({
            path: `/video-transcripts/${video}`,
            entryLinkDepth: 2,
            entryFields: ['*']
        });

        if (!resPage.entry) {
            return { error: true };
        }

        const ancestors = await client.nodes.getAncestors({
            id: resPage.id,
            entryFields: ['title']
        });

        return {
            entry: resPage.entry,
            ancestors
        };
    });

    if (error) {
        return { notFound: true };
    } else {
        setCacheHeaders(res, surrogateKeys);

        return { props: data };
    }
};

export default Video;
